export default {
	setTitle (currentRoute, appName) {
		if (currentRoute.includes('coaching')) {
			if (currentRoute.includes('school')) document.title = `Resumen General - ${appName}`;
			else if (currentRoute.includes('academicLevels')) document.title = `Nivel Escolar - ${appName}`;
			else if (currentRoute.includes('languages')) document.title = `Idiomas - ${appName}`;
			else if (currentRoute.includes('teachers')) document.title = `Docentes - ${appName}`;
		} else document.title = `${appName}`;
	}
};



// WEBPACK FOOTER //
// ./src/services/Dom.js